import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Alert } from '@bingads-webui-react/alert';

export const TurnOnAllAlert = () => {
  const i18n = useContext(I18nContext);
  return (
    <Alert
      message={
        <>
          <b>{i18n.getString(_TL_('For the best results,'))}</b> {i18n.getString(_TL_('consider turning on all asset types.'))}
        </>
      }
      level="Info"
      icon={(<div className="alert-image" />)}
      dismissible={false}
    />
  );
};

export const FullyOptimizedAlert = () => {
  const i18n = useContext(I18nContext);
  return (
    <Alert
      message={
        <>
          {i18n.getString(_TL_('Automatically generated assets are fully optimized.'))}
        </>
      }
      level="Confirmation"
      icon={(<div className="alert-image" />)}
      dismissible={false}
    />
  );
};
